import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import selectOldMeetingMessageOption from '../actions/selectOldMeetingMessageOption';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';
/**
 * Specifies the option to toggle the remove old meeting message options under the invitation settings
 */
var DeleteOldMeetingMessageOption = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteOldMeetingMessageOption, _super);
    function DeleteOldMeetingMessageOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOldMeetingMessageSettingChange = function (ev, checked) {
            selectOldMeetingMessageOption(checked);
        };
        return _this;
    }
    DeleteOldMeetingMessageOption.prototype.render = function () {
        var oldMeetingMessageOption = getOldMeetingMessgeOption();
        return (React.createElement(OptionsCheckbox, { label: strings.options_delete_invitations_and_responses, checked: oldMeetingMessageOption, onChange: this.onOldMeetingMessageSettingChange }));
    };
    DeleteOldMeetingMessageOption = tslib_1.__decorate([
        observer
    ], DeleteOldMeetingMessageOption);
    return DeleteOldMeetingMessageOption;
}(React.Component));
export default DeleteOldMeetingMessageOption;
//# sourceMappingURL=DeleteOldMeetingMessageOption.js.map